module.exports = "<div id=\"activityCanvasWrapper\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/app/dashboard/charts/activity-chart/activity-chart.component.html
// module id = ../../../../../src/app/dashboard/charts/activity-chart/activity-chart.component.html
// module chunks = main